export default __webpack_public_path__ + "static/9_21-ab9eb0226f134021494b69d838090d0a.png";